import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import { xray } from 'lib/xray';
import React, { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    quotaLandingLoadProductsThresholdMobile,
    quotaLandingLoadProductsTimeout,
} from 'reactApp/appHelpers/featuresHelpers/features/quotaLandingLoadProductsTimeouts';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { loadQuotaLandingProducts } from 'reactApp/modules/quotaLanding/quotaLanding.module';
import { useIntersecObsrWithParams } from 'reactApp/sections/QuotaLanding/hooks/useIntersecObsrWithParams';
import { Placeholder } from 'reactApp/ui/Placeholder/Placeholder';

import styles from './MobileTariffCardLoader.css';

interface MobileTariffCardLoaderProps {
    isExpand?: boolean;
    isDark?: boolean;
    isTariffsPage?: boolean;
    headerHeight: number;
}

export const MobileTariffCardLoader = ({ isExpand, isDark, isTariffsPage, headerHeight }: MobileTariffCardLoaderProps) => {
    const dispatch = useDispatch();
    const productsLoadTimer = useRef<NodeJS.Timeout | null>(null);
    const { isLoading, isLoaded } = useSelector(ProductsSelectors.getLifeCycleState);

    const onIntersecting = useCallback(() => {
        /**
         * Загружаем продукты если юзера доскролил до блока и остался
         * на нем какое-то время (quotaLandingLoadProductsTimeout)
         */
        if (!isLoaded && !isLoading && !productsLoadTimer?.current && !isTariffsPage && quotaLandingLoadProductsTimeout) {
            const id = setTimeout(() => {
                xray.send('quota_tariffs_timeout_load_mobile');
                dispatch(loadQuotaLandingProducts());
            }, quotaLandingLoadProductsTimeout);

            productsLoadTimer.current = id;
        }
    }, [isLoaded, isLoading, dispatch, isTariffsPage]);

    const onIntersectingOut = useCallback(() => {
        if (productsLoadTimer?.current) {
            /**
             * Сбрасываем таймер загрузки продуктов
             * Нужно чтобы продукты не грузились когда происходит быстрый якорный скролл.
             */
            clearTimeout(productsLoadTimer.current);
            productsLoadTimer.current = null;
        }
    }, []);

    const refIntersection = useIntersecObsrWithParams({
        onIntersecting,
        onIntersectingOut,
        isMobile: true,
        headerHeight,
        threshold: quotaLandingLoadProductsThresholdMobile,
    });

    return (
        <div className={classNames(styles.root, { [styles.root_dark]: isDark })} ref={refIntersection}>
            <Spacing size={78} />
            <div className={styles.quota}>
                <Placeholder />
            </div>

            {isExpand && (
                <>
                    <Spacing size={25} />

                    <div className={styles.informer}>
                        <Placeholder />
                    </div>

                    <Spacing size={31} />

                    <div className={styles.features}>
                        {Array.from(new Array(4)).map((_, idx) => (
                            <>
                                <div className={styles.feature} key={idx}>
                                    <Placeholder />
                                </div>
                                <Spacing size={15} />
                            </>
                        ))}
                    </div>
                </>
            )}

            <Spacing size={isExpand ? 31 : 47} />
            <div className={styles.buttons}>
                <div className={styles.button}>
                    <Placeholder />
                </div>
                <div className={styles.button}>
                    <Placeholder />
                </div>
            </div>
        </div>
    );
};
